import React, { useContext, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { AppContext } from '@state/context'
import { openPanelWithData } from '@state/actions/panelsActions'
import {
  PANELS,
  HEADING_TYPE,
  BUTTON_SIZE,
  BUTTON_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  COLORS,
  AVATAR_SIZE,
} from '@helpers/constants'
import { SchoolGroupCardStyle } from './style'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import Icon from '@components/Icon'
import Divider from '@components/Divider'
import { useCurrentUser } from '@hooks/useCurrentUser'
import Tooltip from '@components/Tooltip'
import Avatar from '@components/Avatar'
import { storagePath } from '@helpers/variables'

const placeholder = '/static/teacher_placeholder.jpg'

const SchoolGroupCard = (props) => {
  const {
    schoolGroup: { id, name, students, books, creator },
  } = props
  const { currentUser } = useCurrentUser()
  const [, dispatch] = useContext(AppContext)
  const editButtonRef = useRef()
  const [showEditTooltip, setShowEditTooltip] = useState(false)

  return (
    <div className={SchoolGroupCardStyle.container}>
      <div className={'flex items-center justify-between'}>
        <Heading
          size={TEXT_SIZES.LARGE}
          headingLevel={HEADING_TYPE.H2}
        >
          {name}
        </Heading>

        <div
          className={'flex items-center justify-end'}
          // style={schoolGroup && { width: 'calc(100% - 5.5rem)' }}
        >
          <h5
            className='pr-3 font-medium font-secondary text-black text-right text-ellipsis overflow-hidden'
            style={{ maxWidth: 'calc(100% - 3rem)' }}
          >
            {creator?.first_name} {creator?.last_name}
          </h5>
          <Avatar
            user={`${creator?.first_name} ${creator?.last_name}`}
            url={`${storagePath}/${creator?.image ?? placeholder}`}
            size={AVATAR_SIZE.SMALL}
          />
        </div>
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <div className={'flex justify-between items-end mt-auto'}>
        <div>
          <div className={'flex items-center'}>
            <Icon icon={'Classes'} />
            <Text
              size={TEXT_SIZES.XXSMALL}
              extraClasses={'pl-2'}
            >
              Elever: {students.length}
            </Text>
          </div>

          <div className={'flex items-center'}>
            <Icon icon={'Book'} />
            <Text
              size={TEXT_SIZES.XXSMALL}
              extraClasses={'pl-2'}
            >
              Delade böcker: {books.length}
            </Text>
          </div>
        </div>

        <div className={'flex'}>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.MEDIUM}
            to={`/grupp/${id}`}
            margin
          >
            Visa grupp
          </Button>

          <div
            ref={editButtonRef}
            onMouseOver={() => setShowEditTooltip(true)}
            onMouseLeave={() => setShowEditTooltip(false)}
          >
            <Button
              type={BUTTON_TYPE.DARK_GREY}
              size={BUTTON_SIZE.ICON_CIRCLE}
              disabled={currentUser?.id !== creator?.id}
              handleClick={() => {
                dispatch(
                  openPanelWithData({ panel: PANELS.EDIT_SCHOOL_GROUP, data: {
                    schoolGroupId: id
                  } })
                )
              }}
              icon={'Pencil'}
            />
            {currentUser?.id !== creator?.id && (
              <Tooltip
                referenceElement={editButtonRef.current}
                show={showEditTooltip}
              >
                <Text color={COLORS.WHITE.TEXT}>
                  Du kan inte redigera en annan lärares grupp.
                </Text>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

SchoolGroupCard.propTypes = {
  schoolGroup: PropTypes.object,
  size: PropTypes.string,
}

export default SchoolGroupCard
